import { mapTargetBySelectors } from '@/features/shared/HOCs/withGTM';
import { OnDatalayerProps } from '@/features/shared/HOCs/withGTM.interface';

enum Selectors {
  // Target
  CTA = '.gtm-cta',
  // Content
  DocumentHeadline = '.gtm-cta-headline',
}

export const mapTarget = mapTargetBySelectors([Selectors.CTA]);

export const onDatalayer = ({ componentRef, target }: OnDatalayerProps) => {
  if (!target) {
    return undefined;
  }

  const documentHeadline =
    componentRef?.current?.querySelector(Selectors.DocumentHeadline)?.textContent || '';
  const href = target?.href || '';
  const variantName = (target?.closest('[data-datalayer-variant]') as HTMLDivElement)?.dataset
    ?.datalayerVariant;

  return {
    event: 'clickCTA',
    eventCategory: 'CTA',
    documentHeadline,
    ...(!!href && { href }),
    ...(variantName && { variant_name: variantName }),
  };
};
